<template>
    <div class="questions-answers__content" ref="test">
        <div v-if="isDesktop" class="questions-answers__content-title">
            <img class="questions-answers__content-icon" src="@/assets/svg/icons/question_answers/icon_faq.svg" alt="" />
            <p class="questions-answers__content-text">Вопросы <br/>и ответы</p>
        </div>
        <div class="questions-answers__block" v-bind:class="'questions-answers__block--'+questionName">
            <div class="questions-answers__block-title">
                <img class="questions-answers__block-icon" v-bind:src="questionImage" alt="" />
                <p class="questions-answers__block-text" v-html="questionText"></p>
            </div>
            <tabs v-if="isTabs" :options="{ useUrlFragment: false }">
                <tab v-for="items in stateList.list" :name="items.text">
                    <ul class="questions-answers__block-list" v-if="elementIsObject(items.content)">
                        <template v-for="item in items.content">
                            <router-link class="questions-answers__block-item"
                                    v-bind:class="'questions-answers__block-item--'+item.name"
                                    :key="item.id"
                                    :to="{ name: 'AnswerType',
                                    params: {
                                        questionName: questionName,
                                        questionText: questionText,
                                        questionImage: questionImage,
                                        answerName: item.name,
                                        answerText: item.content,
                                    }
                                }">
                                <router-link class="questions-answers__item-title"
                                    v-if="thisQuestion == item.name"
                                    :to="{ path: 'QuestionType',
                                    params: {
                                        questionName: questionName,
                                        questionText: questionText,
                                        questionImage: questionImage,
                                        answerName: item.name,
                                        answerText: item.content,
                                    }
                                }">
                                    <p class="questions-answers__item-title-text" v-html="item.text"></p>
                                    <img class="questions-answers__item-title-icon" src="@/assets/svg/icons/question_answers/icon_plus.svg" alt="">
                                </router-link>
                                <div class="questions-answers__item-title" v-else>
                                    <p class="questions-answers__item-title-text" v-html="item.text"></p>
                                    <img class="questions-answers__item-title-icon" src="@/assets/svg/icons/question_answers/icon_plus.svg" alt="">
                                </div>
                                <keep-alive>
                                    <answer :answerText="item.content" :answerName="item.name" v-if="$route.params.answerName === item.name"></answer>
                                </keep-alive>
                            </router-link>
                        </template>
                    </ul>
                    <div class="questions-answers__block-content" v-else v-html="items.content"></div>
                </tab>
            </tabs>
            <ul class="questions-answers__block-list" v-else-if="haveStateList">
                <template v-for="item in stateList.list">
                    <router-link class="questions-answers__block-item"
                            v-bind:class="'questions-answers__block-item--'+item.name"
                            :key="item.id"
                            :to="{ name: 'AnswerType',
                            params: {
                                questionName: questionName,
                                questionText: questionText,
                                questionImage: questionImage,
                                answerName: item.name,
                                answerText: item.content,
                            }
                        }">
                        <router-link class="questions-answers__item-title"
                                v-if="thisQuestion == item.name"
                                :to="{ name: 'QuestionType',
                                params: {
                                    questionName: questionName,
                                    questionText: questionText,
                                    questionImage: questionImage,
                                    answerName: item.name,
                                    answerText: item.content,
                                }
                            }">
                            <p class="questions-answers__item-title-text" v-html="item.text"></p>
                            <img class="questions-answers__item-title-icon" src="@/assets/svg/icons/question_answers/icon_plus.svg" alt="">
                        </router-link>
                        <div class="questions-answers__item-title" v-else>
                            <p class="questions-answers__item-title-text" v-html="item.text"></p>
                            <img class="questions-answers__item-title-icon" src="@/assets/svg/icons/question_answers/icon_plus.svg" alt="">
                        </div>
                        <keep-alive>
                            <answer :answerText="item.content" :answerName="item.name" v-if="$route.params.answerName === item.name"></answer>
                        </keep-alive>
                    </router-link>
                </template>
            </ul>
            <div class="questions-answers__block-content" v-else-if="stateList.content != undefined" v-html="stateList.content"></div>
        </div>
    </div>
</template>

<script>
	import {TOGGLE_LOADER} from "@/storage/mutations";
    import answer from '@/views/site/answer';
	import widthMixin from '@/modules/mixins/widthMixin';

    export default{
    	name: 'Question',
        metaInfo: {
            title: 'Вопросы и ответы'
        },
        components: {answer},
	    mixins: [widthMixin],
        beforeRouteEnter ( to, from, next){
    	    next( vm => {
		        to.params.questionName != undefined ? vm.questionName = to.params.questionName : '';
		        to.params.questionImage != undefined ? vm.questionImage = to.params.questionImage : '';
		        to.params.questionText != undefined ? vm.questionText = to.params.questionText : '';
//		        console.log(vm.$route.params.questionName);
		        vm.$store.commit(TOGGLE_LOADER, {state: false});
            });
        },
	    beforeRouteUpdate (to, from, next) {
		    this.questionName = to.params.questionName;
            this.questionImage = to.params.questionImage;
            this.questionText = to.params.questionText;
            this.$store.commit(TOGGLE_LOADER, {state: false});
            next();
        },
        data() {
    		return {
    		    questionName: 'often-asked',
			    questionImage: require('@/assets/svg/icons/question_answers/icon_star.svg'),
			    questionText: 'Часто спрашивают',
            }
        },
        computed: {
	        thisQuestion: function () {
		        return this.$route.path.split('/').pop();
	        },
	        isTabs: function () {
		        return typeof this.stateList.selector != 'undefined';
	        },
        	haveStateList: function () {
                return typeof this.stateList.list != 'undefined';
	        },
            stateList: function () {
                return this.$store.getters['faq/question'](this.questionName);
            },
	        toggleIcon: function () {
		        return {
			        'icon-close': this.showAbout,
			        'icon-plus': !this.showAbout
		        }
	        }
        },
	    methods: {
		    elementIsObject: function (element) {
			    return typeof element == 'object';
		    },
        },
    }
</script>

<style lang="scss">
@import "~@/assets/scss/variable";

.questions-answers {
    .tabs-component {
        &-tabs {
            display: inline-flex;
            flex-flow: row nowrap;
            align-items: flex-start;
            justify-content: space-between;

            width: 100%;
            margin-bottom: 17px;
            list-style: none;
        }
        &-tab {
            width: 45%;
            height: 40px;
            &-a {
                display: inline-flex;
                flex-flow: row wrap;
                align-items: flex-start;
                justify-content: center;

                width: 100%;
                background: $white;
                border-bottom: 3px solid $purple-site;
                border-radius: 12px 12px 0 0;

                color: $purple-site;
                font-size: 18px;
                line-height: 34px;
                font-family: $RobotoBold;
                text-align: center;
                text-decoration: none;
            }
            &.is-active {
                .tabs-component-tab-a {
                    background: $orange-o-25;
                    border-color: $yellow-1;
                    color: $yellow-1;
                }
            }
        }
    }
    &__block {
        width: 100%;
    }
    &__block-title {
        display: inline-flex;
        flex-flow: row wrap;
        justify-content: flex-start;
        align-items: center;

        width: 100%;
        padding: 20px 0;
    }
    &__block-text {
        text-align: left;
    }
    &__block-icon {
        max-width: 42px;
        max-height: 40px;
        margin-right: 14px;
    }
    &__block-item {
        display: inline-flex;
        flex-flow: column wrap;
        align-items: flex-start;
        justify-content: center;

        width: 100%;
        list-style: none;
        text-decoration: none;
        border-top: 1px solid $gray-mint;
    }
    &__item-title {
        display: inline-flex;
        flex-flow: row nowrap;
        align-items: center;
        justify-content: space-between;

        width: 100%;
        min-height: 44px;
    }
    &__item-title-text {
        color: $gray-dim-dark;
        text-align: left;
        font-family: $RobotoRegular;
        font-size: 14px;
        line-height: 23px;
    }
    &__item-title-icon {
        width: 15px;
        height: 15px;
    }
    &__item-text {
        display: none;
        width: 100%;
        margin-bottom: 30px;
        text-align: left;
        color: $gray-dim-dark;
        font-family: $RobotoRegular;
        font-size: 16px;
        line-height: 24px;
    }
    &__block-item.router-link-active {
        .questions-answers__item-text {
            display: inline-block;
        }
    }
    &__block-item.router-link-active &__item-title {
        margin-bottom: 10px;
        text-decoration: none;
    }
    &__block-item.router-link-active &__item-title-text {
        font-size: 18px;
        line-height: 27px;
        font-family: $RobotoBold;
    }
    &__block-item.router-link-active &__item-title-icon {
        width: 16px;
        height: 16px;
        transform: rotate(45deg);
    }
    &__block-content {
        width: 100%;
        text-align: left;
        color: $gray-dim-dark;
        font-family: $RobotoBold;
        font-size: 16px;
        line-height: 24px;
    }
    &__block-table {
        width: 100%;
        border: 1px solid black;
        border-collapse: collapse;
        tr {
            td, th {
                width: 50%;
                padding: 2px 4px;
                border: 1px solid black;
                vertical-align: top;
                font-family: $RobotoRegular;
            }
        }
        .block-table--blacking {
            tr {
                td:nth-child(2n), th:nth-child(2n) {
                    background: #F3F3F3;
                }
            }
        }
    }
    &__block-num-list {
        margin-left: 40px;
    }
}
</style>